import React, { useState } from "react";
import PhotoAlbum from "react-photo-album";
import photos from "./photos";
import Lightbox from "../../components/common/Lightbox/Lightbox";

const Portfolios = () => {
  const [showPreview, setShowPreview] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  // Handler for clicking an image in the album
  const handleClick = ({ index }) => {
    setImageIndex(index);
    setShowPreview(true);
  };

  // Custom renderer to add border radius
  const photoRenderer = ({ imageProps }) => (
    <img
      {...imageProps}
      style={{
        ...imageProps.style,
        borderRadius: "12px",
        objectFit: "cover",
        // width: "100%",
        // height: "100%",
      }}
      alt={imageProps.alt}
    />
  );

  return (
    <>
      {/* <div className={"text-start"}>
        <SecondaryHeading
          variant={"MainParagraphHeading"}
          className={"text-offblack"}
        >
          Portfolio
        </SecondaryHeading>
      </div> */}
      {showPreview && (
        <Lightbox
          images={photos}
          initialIndex={imageIndex}
          onClose={() => setShowPreview(false)}
        />
      )}
      <div className="mt-5">
        <PhotoAlbum
          layout="masonry"
          photos={photos}
          onClick={handleClick}
          spacing={32}
          columns={(containerWidth) => {
            if (containerWidth < 640) return 1;
            if (containerWidth < 1024) return 2;
            return 3;
          }}
          renderPhoto={photoRenderer}
        />
      </div>
    </>
  );
};

export default Portfolios;
